export const healthStatuses = [
  "unknown",
  "operational",
  "offline",
  "error",
] as const;
